import { RuleChange } from '../../../cashflow';
import { TransactionEntryCategoryFieldsFragment } from '../../../graphql/generated';

export type ChangeValues = {
    category?: TransactionEntryCategoryFieldsFragment;
    merchantName?: string;
    tagNames?: string[];
    isHidden?: boolean;
};

export const getChangeValues = ({
    enabledValidChanges,
    transactionEntryCategoriesMapById,
    merchantName,
}: {
    enabledValidChanges: RuleChange[];
    transactionEntryCategoriesMapById:
        | Record<string, TransactionEntryCategoryFieldsFragment>
        | undefined;
    merchantName: string | undefined;
}) => {
    const changeValues: ChangeValues = {};

    for (const change of enabledValidChanges) {
        switch (change.field) {
            case 'categoryId':
                if (transactionEntryCategoriesMapById) {
                    changeValues.category =
                        transactionEntryCategoriesMapById[change.value];
                }
                break;
            case 'merchantId':
                if (merchantName) {
                    changeValues.merchantName = merchantName;
                }
                break;
            case 'tagNames': {
                changeValues.tagNames = change.value;
                break;
            }
            case 'isHidden':
                changeValues.isHidden = change.value;
                break;
        }
    }

    return changeValues;
};
